module.exports = __webpack_public_path__ + "media/22.2ac563a6.mp3";